import { z } from 'zod'
import type {HttpClient} from "@jantm/model-core";
import {createInvoiceApi} from "@/api/wiser/invoice.ts";
import {defineModel} from '@jantm/model-core'
import InvoiceFullListItem from "@/templates/Wiser/InvoiceFullListItem.vue";
import InvoiceFullDetail from "@/templates/Wiser/InvoiceFullDetail.vue";
import {
  optionalBoolSchema, optionalDateSchema,
  optionalDateTimeSchema,
  optionalNumberArraySchema, optionalNumberOrStringSchema,
  optionalNumberSchema,
  optionalStringSchema
} from "@/types/global.ts";
export const invoiceSchema = z.object({
  id: z.int(),
  "title": optionalStringSchema,
  "printfactuur": optionalBoolSchema,
  "factuurdatum": optionalDateSchema,
  "factuurnummer": optionalNumberSchema,
  "vervaldatum": optionalDateSchema,
  "vestiging": optionalNumberSchema,
  "omschrijving": optionalStringSchema,
  "contactpersoon": optionalNumberOrStringSchema,
  "naam": optionalStringSchema,
  "adres": optionalStringSchema,
  "postcode": optionalStringSchema,
  "huisnummer": optionalStringSchema,
  "toevoeging": optionalStringSchema,
  "woonplaats": optionalStringSchema,
  "land": optionalStringSchema,
  "btwnummer": optionalStringSchema,
  "is_gecrediteerd": optionalBoolSchema,
  "is_credit": optionalBoolSchema,
  "referentie": optionalStringSchema,
  "betalingsconditie": optionalNumberArraySchema,
  "definitief": optionalBoolSchema,
  "doorgeboekt": optionalNumberOrStringSchema,
  "subtotaal": optionalNumberSchema,
  "btw": optionalNumberSchema,
  "totaal": optionalNumberSchema,
  "openstaand": optionalNumberSchema,
  "match_state": optionalStringSchema,
  "aanvullende_info": optionalStringSchema,
  "betalingbijfactuur": optionalNumberArraySchema,
  "factuurregelsonderfactuur": optionalNumberArraySchema,
  "inverse-factuuronderrelatie": optionalNumberSchema,
  "added_on": optionalDateTimeSchema,
  "changed_on": optionalDateTimeSchema
})

export type Invoice = z.infer<typeof invoiceSchema>

export const invoiceCollectionSchema = z.array(invoiceSchema)

export type InvoiceCollection = z.infer<typeof invoiceCollectionSchema>

export const invoiceFilterSchema = z.object({
  fields: z.array(invoiceSchema.keyof()).nullish().optional(),
  page: optionalStringSchema.default('1'),
  perPage: optionalStringSchema.default('25'),
  filters: optionalStringSchema,
})
export type InvoiceFilter = z.infer<typeof invoiceFilterSchema>

export type InvoiceFilters = {
  id?: string
  factuurnummer?: string
  factuurdatum?: string
}

export interface CreateInvoiceModelOptions {
  client: HttpClient
  /** Override when this model does not live at `/api/invoices`. */
  endpoint?: string
}

export function createInvoiceModel(options: CreateInvoiceModelOptions) {
  return defineModel({
    name: 'Invoice',
    schema: invoiceSchema,
    collectionSchema: invoiceCollectionSchema,
    filterSchema: invoiceFilterSchema,
    api: createInvoiceApi(options.client, options.endpoint),
    identify: (invoice: Invoice) => String(invoice.id),
    templates: { FullListItem: InvoiceFullListItem, FullDetail: InvoiceFullDetail },
    // toItems: (collection) => Object.entries(collection.items).map(([, v]) => v),
    // toTotal: (collection => collection.metadata?.total)
  })
}

export type InvoiceModel = ReturnType<typeof createInvoiceModel>

declare module '@jantm/model-core' {
  interface ModelRegistry {
    Invoice: InvoiceModel
  }
}
